//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BCollapse, VBToggle } from 'bootstrap-vue'
import ProfileData from '~/components/profile/mixins/ProfileData'

import Vue from 'vue'
Vue.directive('b-toggle', VBToggle)

import {mapGetters} from 'vuex'

export default {

    name: 'ProfileFavorites',

    mixins: [ProfileData],

    components: { BCollapse },

    props: {
        company: {
        },
        destination: {
        },
        internalVisit: {
            type: Boolean,
            default: false
        },
        isScreenshot: {
            type: Boolean,
            default: false
        },
    },

    methods: {

        ClearAllFavorites() {
            this.$store.dispatch("search/ClearAllFavorites");
        },

        addAllToRequest() {
            this.$store.dispatch("search/addAllToRequest");
        },


    },

    computed: {

        ...mapGetters('search', ['favoriteCart', 'companies']),

        cartCount() {
            return this.favoriteCart.length;
        },

    },

}

